'use client';

import { useLocale, useSwitchLocale } from '@/i18n/client';
import { LOCALES, type Locale } from '@/i18n';

const LABELS: Record<Locale, string> = { rw: 'RW', en: 'EN' };
const NAMES: Record<Locale, string> = { rw: 'Kinyarwanda', en: 'English' };

/** RW ⇄ EN toggle. Kinyarwanda is the default; the choice persists in a cookie. */
export function LanguageSwitcher() {
  const locale = useLocale();
  const switchLocale = useSwitchLocale();
  return (
    <div className="vn-lang" role="group" aria-label="Language / Ururimi">
      {LOCALES.map((value) => (
        <button
          key={value}
          type="button"
          className={`vn-lang__opt${locale === value ? ' is-active' : ''}`}
          aria-pressed={locale === value}
          title={NAMES[value]}
          onClick={() => {
            if (locale !== value) switchLocale(value);
          }}
        >
          {LABELS[value]}
        </button>
      ))}
    </div>
  );
}
